import React from "react";

interface IProps {
    showRecommended: boolean;
    recommended: boolean | null;
}

export const ReviewRecommended = (props: IProps): React.JSX.Element | null => {
    if (!props.showRecommended) {
        return null;
    }
    if (props.recommended === null) {
        return null;
    }

    const reviewMsg = props.recommended
        ? "YES, I do recommend this product!"
        : "NO, I do not recommend this product";

    return (
        <div>
            <strong>{reviewMsg}</strong>
        </div>
    );
};
